import { MAIL_COMPLAINT_RATE_FLAG, type MailWindowStats } from "@feedback-hub/contract/browser";

export function pct(rate: number | null): string {
  if (rate == null) return "—";
  return `${(rate * 100).toFixed(2)}%`;
}

export function count(n: number): string {
  return n.toLocaleString();
}

/** A window is flagged when it has sends and its complaint rate is at or above the plan threshold. */
export function isFlagged(w: MailWindowStats): boolean {
  return w.complaintRate != null && w.complaintRate >= MAIL_COMPLAINT_RATE_FLAG;
}
